import { render, staticRenderFns } from "./quotation-details.vue?vue&type=template&id=1fffff27&"
import script from "./quotation-details.vue?vue&type=script&lang=js&"
export * from "./quotation-details.vue?vue&type=script&lang=js&"
import style0 from "./quotation-details.vue?vue&type=style&index=0&id=1fffff27&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports